module.exports = __webpack_public_path__ + "static/media/Display.92cc8079.jpg";